<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="[
      item.customClass,
      {
        'active': isActive,
        'disabled': item.disabled
      }
    ]"
  >
    <b-link
      v-if="item.modal"
      class="d-flex align-items-center"
      @click="openModal(item)"
    >
      <img
        v-if="item.iconImage"
        :src="item.iconImage"
        class="nav-menu-icon-image"
        alt=""
      />
      <feather-icon v-else :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
    <b-link v-else
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <span v-if="item.iconImage" class="nav-menu-icon-wrap">
        <img
          :src="item.iconImage"
          class="nav-menu-icon-image"
          alt=""
        />
        <svg
          v-if="item.sparkleOnActive && isActive"
          class="zi-sparkle"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M12 0l2.2 7.8L22 10l-7.8 2.2L12 20l-2.2-7.8L2 10l7.8-2.2z" />
        </svg>
      </span>
      <feather-icon v-else :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'
import { bus } from "@/main.js";

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },
  methods: {
    openModal(item){
      
      if(item.resource == 'Create OKR'){
        if(!this.$can('reporting_manager') && !this.$can('Organisation OKR Manager')){
          return window.open(item.href, '_self');
        }else{
          bus.$emit('openModal',item.modal);
        }
      }
    },
  },

}
</script>

<style scoped>
.nav-menu-icon-wrap {
  position: relative;
  display: inline-flex;
  margin-right: 10px;
  flex-shrink: 0;
}

.nav-menu-icon-image {
  width: 20px;
  height: 20px;
  object-fit: contain;
  margin-right: 0;
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

/*
  "Ask Zircly AI" nav item — a deliberate one-off treatment (via
  item.customClass/sparkleOnActive), not a change to nav items generally.
  Hover keeps the existing lift-free, flat-background convention everywhere
  else in the sidebar but adds a soft brand-green lift + glow + icon tilt;
  active keeps the app's existing light-gray active background untouched
  and layers a slow, subtle sparkle pulse on top — reads as "AI is active
  here" without looping fast enough to be distracting.
*/
.zi-nav-item > a {
  transition: transform 0.22s ease, box-shadow 0.22s ease, background-color 0.22s ease;
}

.zi-nav-item:hover > a {
  background-color: rgba(56, 178, 45, 0.1) !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px -2px rgba(56, 178, 45, 0.35);
}

.zi-nav-item:hover .nav-menu-icon-image {
  transform: scale(1.12) rotate(-6deg);
}

.zi-sparkle {
  position: absolute;
  top: -3px;
  right: -4px;
  width: 9px;
  height: 9px;
  color: #38B22D;
  pointer-events: none;
  animation: zi-sparkle-pulse 2.6s ease-in-out infinite;
}

@keyframes zi-sparkle-pulse {
  0%, 100% {
    opacity: 0.4;
    transform: scale(0.8) rotate(0deg);
  }
  50% {
    opacity: 1;
    transform: scale(1.15) rotate(8deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .zi-sparkle {
    animation: none;
    opacity: 0.85;
  }

  .zi-nav-item:hover .nav-menu-icon-image {
    transform: none;
  }

  .zi-nav-item:hover > a {
    transform: none;
  }
}
</style>
